const Index = () => import('@/components/Index')
const Information = () => import('@/client/components/public/Information')
const VersionComparison = () => import('@/client/components/public/VersionComparison')
const ExtendSubscription = () => import('@/client/components/public/ExtendSubscription')
const OrderedSubscription = () => import('@/client/components/public/OrderedSubscription')
const Changelog = () => import('@/client/components/public/Changelog')
const Eula = () => import('@/client/components/public/Eula')
// const PoweredBy = () => import('@/client/components/public/PoweredBy')
const Disclaimer = () => import('@/client/components/public/Disclaimer')
const Impressum = () => import('@/client/components/public/Impressum')
const Wartung = () => import('@/components/Wartung')
const PrivacyPolicy = () => import('@/client/components/public/PrivacyPolicy')
const PageNotFound = () => import('@/client/components/public/PageNotFound')
const HelpAndSupport = () => import('@/client/components/public/HelpAndSupport')
const CustomerExamples = () => import('@/client/components/public/CustomerExamples')
const Settings = () => import('@/client/views/Settings')
const Faq = () => import('@/client/views/Faq')
const Messages = () => import('@/client/views/Messages')
const AccessToAccount = () => import('@/client/views/AccessToAccount')
const LiveData = () => import('@/client/views/visualization/LiveData')
const Feedback = () => import('@/client/components/public/Feedback')
const Login = () => import('@/client/components/public/Login')
const Register = () => import('@/client/components/public/Register')
const RegisterInfo = () => import('@/client/components/public/RegisterInfo')
const ConfirmRegistration = () => import('@/client/components/public/ConfirmRegistration')
const ForgotPassword = () => import('@/client/components/public/ForgotPassword')
const ResendRegistrationEmail = () => import('@/client/components/public/ResendRegistrationEmail')
const ConfirmChangeEmail = () => import('@/client/components/public/ConfirmChangeEmail')
const FirmwareUpdate = () => import('@/client/components/public/FirmwareUpdate')
/* Visualization */
const Ownerships = () => import('@/client/views/visualization/Ownerships')
const Ownership = () => import('@/client/views/visualization/Ownership')
const Modules = () => import('@/client/views/visualization/Modules')
const OwnershipClaim = () => import('@/client/views/visualization/OwnershipClaim')
const Initialize = () => import('@/client/views/visualization/Initialize')
const Filters = () => import('@/client/views/visualization/Filters')
const Filter = () => import('@/client/views/visualization/Filter')
const Images = () => import('@/client/views/visualization/Images')
const Image = () => import('@/client/views/visualization/Image')
const LiveSystems = () => import('@/client/views/visualization/LiveSystems')
const LiveSystem = () => import('@/client/views/visualization/LiveSystem')
const Diagrams = () => import('@/client/views/visualization/Diagrams')
const Diagram = () => import('@/client/views/visualization/Diagram')
const DiagramShow = () => import('@/client/views/visualization/DiagramShow')
const Downloads = () => import('@/client/views/visualization/Downloads')
const Download = () => import('@/client/views/visualization/Download')
const ScheduledDownloads = () => import('@/client/views/visualization/ScheduledDownloads')
const ScheduledDownload = () => import('@/client/views/visualization/ScheduledDownload')
const Reports = () => import('@/client/views/visualization/Reports')
const Report = () => import('@/client/views/visualization/Report')
/* /views */
const Dashboard = () => import('@/client/views/Dashboard')
const AcceptEula = () => import('@/client/views/AcceptEula')
/* Parameterization */
// const ParameterizationToolRPT = () => import('@/client/views/parameterization/RPT') // Deprecated
const Parameterization = () => import('@/client/views/parameterization/Parameterization')
/* Monitoring */
const ErrorLogs = () => import('@/client/views/monitoring/ErrorLogs')
const Notifications = () => import('@/client/views/monitoring/Notifications')
const Notification = () => import('@/client/views/monitoring/Notification')
/* Settings */
const Profile = () => import('@/client/views/settings/Profile')
const Coupon = () => import('@/client/views/settings/Coupon')
const DefaultSettings = () => import('@/client/views/settings/DefaultSettings')
const BackupCreate = () => import('@/client/views/settings/BackupCreate')
const BackupRestore = () => import('@/client/views/settings/BackupRestore')
const DefaultFilterSettings = () => import('@/client/views/settings/DefaultFilterSettings')
const ResetPassword = () => import('@/client/views/settings/ResetPassword')
const ChangeEmail = () => import('@/client/views/settings/ChangeEmail')
const TwoFactorAuthentication = () => import('@/client/views/settings/TwoFactorAuthentication')
const Templates = () => import('@/client/views/settings/Templates')

const AdminDashboard = () => import('@/client/views/administration/AdminDashboard')
const Km2PasswordSeed = () => import('@/client/views/administration/Km2PasswordSeed')
const OnlineDevices = () => import('@/client/views/administration/OnlineDevices')
const SupportDashboard = () => import('@/client/views/administration/SupportDashboard')
const DistributionDashboard = () => import('@/client/views/administration/DistributionDashboard')
const Statistic = () => import('@/client/views/administration/Statistic')
const OwnershipData = () => import('@/client/views/administration/OwnershipData')
const CheckEmails = () => import('@/client/views/administration/CheckEmails')
/* Tools */
const DataViewer = () => import('@/client/views/tools/DataViewer')
const SettingsDocumentationGenerator = () => import('@/client/views/tools/SettingsDocumentationGenerator')
const DiscoveryTool = () => import('@/client/views/tools/DiscoveryTool')
const ConfirmService = () => import('@/client/views/public/ConfirmService')
const UnsubscribeService = () => import('@/client/views/public/UnsubscribeService')
/* Other Vendors */
const MTFAdmin = () => import('@/client/views/administration/MTFAdmin')

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    alias: ['/inbetriebnahme', '/visualisieren', '/ueberwachen', '/parametrisieren'],
    meta: {
      page: {
        isPublic: true
      },
      footer: {
        spacer: true
      }
    }
  }, {
    path: '/report-confirmation/:token',
    name: 'ConfirmService',
    component: ConfirmService,
    props: true,
    alias: ['/extended-report-confirmation/:token', '/notification-confirmation/:token'],
    meta: {
      page: {
        isPublic: true
      },
      footer: {
        spacer: true
      }
    }
  }, {
    path: '/report-unsubscribe/:token',
    name: 'UnsubscribeService',
    component: UnsubscribeService,
    props: true,
    alias: ['/extended-report-unsubscribe/:token', '/notification-unsubscribe/:token'],
    meta: {
      page: {
        isPublic: true
      },
      footer: {
        spacer: true
      }
    }
  }, {
    path: '/wartung',
    name: 'Wartung',
    component: Wartung,
    meta: {
      page: {
        isPublic: true,
        maintenance: true
      }
    }
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      page: {
        key: 'general.login',
        isPublic: true
      }
    }
  }, {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      breadcrumb: null,
      page: {
        key: 'general.register',
        isPublic: true
      }
    }
  }, {
    path: '/register-info',
    name: 'RegisterInfo',
    component: RegisterInfo,
    meta: {
      breadcrumb: null,
      page: {
        key: 'general.register',
        isPublic: true
      }
    }
  }, {
    path: '/activate/:token',
    name: 'ConfirmRegistration',
    props: true,
    component: ConfirmRegistration,
    meta: {
      page: {
        key: 'general.activation',
        isPublic: true
      }
    }
  }, {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      page: {
        key: 'general.forgotYourPassword',
        isPublic: true
      }
    }
  }, {
    path: '/resend-registration-email',
    name: 'ResendRegistrationEmail',
    component: ResendRegistrationEmail,
    meta: {
      page: {
        key: 'links.didNotReceiveConfirmationInstructions',
        isPublic: true
      }
    }
  }, {
    path: '/reset/password/:token',
    name: 'ResetPassword',
    props: true,
    component: ResetPassword,
    meta: {
      page: {
        key: 'account.changePassword',
        isPublic: true
      }
    }
  }, {
    path: '/change/password',
    name: 'ChangePassword',
    component: ResetPassword,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        path: '/profil',
        key: 'topBar.editProfile'
      }, {
        key: 'account.changePassword'
      }]
    }
  }, {
    path: '/compare-versions',
    name: 'VersionComparison',
    component: VersionComparison,
    meta: {
      page: {
        key: 'general.Versionsvergleich',
        isPublic: true
      }
    }
  }, {
    path: '/extend-professional',
    name: 'ExtendSubscription',
    component: ExtendSubscription,
    alias: ['/extend-business', '/get-professional', '/get-business'],
    meta: {
      page: {
        key: 'general.extendSubscription',
        isPublic: true
      }
    }
  }, {
    path: '/ordered-professional',
    name: 'OrderedSubscription',
    component: OrderedSubscription,
    alias: ['/ordered-business', '/ordered-professional-error', '/ordered-business-error'],
    meta: {
      page: {
        key: 'general.orderedSubscription',
        isPublic: true
      }
    }
  }, {
    path: '/change/email',
    name: 'ChangeEmail',
    component: ChangeEmail,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        path: '/profil',
        key: 'topBar.editProfile'
      }, {
        key: 'account.changeEmail'
      }]
    }
  }, {
    path: '/change-email-confirmation/:token',
    name: 'ConfirmChangeEmail',
    props: true,
    component: ConfirmChangeEmail,
    meta: {
      page: {
        isPublic: true
      },
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        path: '/profil',
        key: 'topBar.editProfile'
      }, {
        key: 'account.changeEmail'
      }]
    }
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      page: {
        key: 'sideBar.dashboard'
      }
    }
  }, {
    path: '/information',
    name: 'Information',
    component: Information,
    meta: {
      page: {
        key: 'general.Funktionsbeschreibung',
        isPublic: true
      }
    }
  }, {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      page: {
        key: 'eula.privacyPolicy',
        isPublic: true
      }
    }
  }, {
    path: '/feedback',
    name: 'Feedback',
    component: Feedback,
    meta: {
      page: {
        key: 'general.feedback'
      }
    }
  }, {
    path: '/visualization/filters',
    name: 'Filters',
    component: Filters,
    meta: {
      page: {
        key: 'sideBar.filters'
      }
    }
  }, {
    path: '/visualization/filter/edit/:id',
    name: 'FilterEdit',
    component: Filter,
    meta: {
      breadcrumb: [{
        path: '/visualization/filters',
        key: 'sideBar.filters'
      }, {
        key: 'visualization.myFilter'
      }]
    }
  }, {
    path: '/visualization/filter/add',
    name: 'FilterAdd',
    component: Filter,
    meta: {
      breadcrumb: [{
        path: '/visualization/filters',
        key: 'sideBar.filters'
      }, {
        key: 'visualization.myFilter'
      }]
    }
  }, {
    path: '/visualization/images',
    name: 'Images',
    component: Images,
    meta: {
      page: {
        key: 'sideBar.images'
      }
    }
  }, {
    path: '/visualization/image/edit/:id',
    name: 'Image',
    component: Image,
    meta: {
      breadcrumb: [{
        path: '/visualization/images',
        key: 'sideBar.images'
      }, {
        key: 'visualization.myImage'
      }]
    }
  }, {
    path: '/visualization/image/add',
    name: 'ImageAdd',
    component: Image,
    meta: {
      breadcrumb: [{
        path: '/visualization/images',
        key: 'sideBar.images'
      }, {
        key: 'visualization.myImage'
      }]
    }
  }, {
    path: '/visualization/live-system/add',
    name: 'LiveSystemAdd',
    component: LiveSystem,
    alias: ['/visualization/scheme/add'],
    meta: {
      breadcrumb: [{
        path: '/visualization/live-systems',
        key: 'sideBar.liveSchemes'
      }, {
        key: 'visualization.myScheme'
      }]
    }
  }, {
    path: '/visualization/live-system/edit/:id',
    name: 'LiveSystemEdit',
    component: LiveSystem,
    alias: ['/visualization/scheme/edit/:id'],
    meta: {
      breadcrumb: [{
        path: '/visualization/live-systems',
        key: 'sideBar.liveSchemes'
      }, {
        key: 'visualization.myScheme'
      }]
    }
  }, {
    path: '/live-system/:id',
    name: 'LiveSystemRaw',
    component: LiveSystem,
    meta: {
      page: {
        key: 'visualization.myScheme',
        plainTemplate: true
      }
    }
  }, {
    path: '/visualization/live-systems',
    name: 'LiveSystems',
    component: LiveSystems,
    alias: ['/visualization/schemes'],
    meta: {
      page: {
        key: 'sideBar.liveSchemes'
      }
    }
  }, {
    path: '/visualization/diagram/show/:id',
    name: 'DiagramShow',
    component: DiagramShow,
    meta: {
      page: {
        key: 'visualization.myDiagram',
        noImageFooter: true,
        color: null
      }
    }
  }, {
    path: '/diagram/:id',
    name: 'PublicDiagram',
    component: DiagramShow,
    meta: {
      isPublic: true,
      page: {
        key: 'visualization.myDiagram',
        plainTemplate: true
      }
    }
  }, {
    path: '/visualization/diagram/edit/:id',
    name: 'DiagramEdit',
    component: Diagram,
    meta: {
      breadcrumb: [{
        path: '/visualization/diagrams',
        key: 'sideBar.diagrams'
      }, {
        key: 'visualization.myDiagram'
      }]
    }
  }, {
    path: '/visualization/diagram/add',
    name: 'DiagramAdd',
    component: Diagram,
    meta: {
      breadcrumb: [{
        path: '/visualization/diagrams',
        key: 'sideBar.diagrams'
      }, {
        key: 'visualization.myDiagram'
      }]
    }
  }, {
    path: '/visualization/diagrams',
    name: 'Diagrams',
    component: Diagrams,
    meta: {
      page: {
        key: 'sideBar.diagrams'
      }
    }
  }, {
    path: '/visualization/download/edit/:id',
    name: 'DownloadEdit',
    component: Download,
    meta: {
      breadcrumb: [{
        path: '/visualization/downloads',
        key: 'sideBar.downloads'
      }, {
        key: 'visualization.myDownload'
      }]
    }
  }, {
    path: '/visualization/download/add',
    name: 'DownloadAdd',
    component: Download,
    meta: {
      breadcrumb: [{
        path: '/visualization/downloads',
        key: 'sideBar.downloads'
      }, {
        key: 'visualization.myDownload'
      }]
    }
  }, {
    path: '/visualization/downloads',
    name: 'Downloads',
    component: Downloads,
    meta: {
      page: {
        key: 'sideBar.downloads'
      }
    }
  }, {
    path: '/visualization/report/edit/:id',
    name: 'ScheduledDownloadEdit',
    component: ScheduledDownload,
    meta: {
      page: {
        requires: 'pro'
      },
      breadcrumb: [{
        path: '/visualization/reports',
        key: 'visualization.scheduledDownloads'
      }, {
        key: 'visualization.myScheduledDownload'
      }]
    }
  }, {
    path: '/visualization/report/add',
    name: 'ScheduledDownloadAdd',
    component: ScheduledDownload,
    meta: {
      page: {
        requires: 'pro'
      },
      breadcrumb: [{
        path: '/visualization/reports',
        key: 'visualization.scheduledDownloads'
      }, {
        key: 'visualization.myScheduledDownload'
      }]
    }
  }, {
    path: '/visualization/reports',
    name: 'Reports',
    component: ScheduledDownloads,
    alias: ['/visualization/scheduled-downloads'],
    meta: {
      page: {
        key: 'visualization.scheduledDownloads',
        requires: 'pro'
      }
    }
  }, {
    path: '/visualization/extended-report/edit/:id',
    name: 'ReportEdit',
    component: Report,
    meta: {
      breadcrumb: [{
        path: '/visualization/extended-reports',
        key: 'sideBar.reports'
      }, {
        key: 'visualization.myReport'
      }]
    }
  }, {
    path: '/visualization/extended-report/add',
    name: 'ReportAdd',
    component: Report,
    meta: {
      breadcrumb: [{
        path: '/visualization/extended-reports',
        key: 'sideBar.reports'
      }, {
        key: 'visualization.myReport'
      }]
    }
  }, {
    path: '/visualization/extended-reports',
    name: 'Extended-Reports',
    component: Reports,
    meta: {
      page: {
        key: 'sideBar.reports',
        requires: 'pro'
      }
    }
  }, {
    path: '/monitoring/error-logs',
    name: 'Error-Logs',
    component: ErrorLogs,
    meta: {
      page: {
        key: 'monitoring.errorLog',
        requires: 'pro'
      }
    }
  }, {
    path: '/monitoring/notification/edit/:id',
    name: 'NotificationEdit',
    component: Notification,
    meta: {
      breadcrumb: [{
        path: '/monitoring/notifications',
        key: 'sideBar.notifications'
      }, {
        key: 'monitoring.myNotification'
      }]
    }
  }, {
    path: '/monitoring/notification/add',
    name: 'NotificationAdd',
    component: Notification,
    meta: {
      breadcrumb: [{
        path: '/monitoring/notifications',
        key: 'sideBar.notifications'
      }, {
        key: 'monitoring.myNotification'
      }]
    }
  }, {
    path: '/monitoring/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: {
      page: {
        key: 'sideBar.notifications',
        requires: 'pro'
      }
    }
  }, {
    path: '/help-support',
    name: 'HelpAndSupport',
    component: HelpAndSupport,
    meta: {
      page: {
        key: 'general.helpAndSupport',
        isPublic: true,
        noImageFooter: false
      }
    }
  }, {
    path: '/kundenbeispiele',
    name: 'CustomerExamples',
    component: CustomerExamples,
    meta: {
      page: {
        key: 'customer.examples',
        isPublic: true
      }
    }
  }, {
    path: '/changelog',
    name: 'Changelog',
    component: Changelog,
    meta: {
      page: {
        key: 'Changelog',
        isPublic: true
      }
    }
  }, {
    path: '/firmware-update',
    name: 'FirmwareUpdate',
    component: FirmwareUpdate,
    props: true,
    meta: {
      page: {
        isPublic: true
      }
    }
  }, {
    path: '/livedata/:id',
    name: 'LiveData',
    component: LiveData,
    props: true,
    meta: {
      breadcrumb: [{
        path: '/devices',
        key: 'subtitle.myDevices'
      }, {
        key: 'show.liveData'
      }]
    }
  }, {
    path: '/messages',
    name: 'Messages',
    component: Messages,
    meta: {
      page: {
        isPublic: false,
        key: 'general.messages'
      }
    }
  }, {
    path: '/faq/:id?',
    name: 'Faq',
    component: Faq,
    meta: {
      page: {
        isPublic: true,
        key: 'FAQ'
      }
    }
  }, {
    path: '/access-to-account',
    name: 'AccessToAccount',
    component: AccessToAccount,
    meta: {
      page: {
        key: 'support.extended'
      }
    }
  }, {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      page: {
        key: 'general.preferences'
      }
    }
  }, {
  /*
    path: '/poweredby',
    name: 'PoweredBy',
    component: PoweredBy,
    meta: {
      page: {
        isPublic: true
      },
      breadcrumb: [{
        path: '/impressum',
        key: 'topBar.imprint'
      }, {
        key: 'Powered by'
      }]
    }
  }, {
  */
    path: '/disclaimer',
    name: 'Disclaimer',
    component: Disclaimer,
    meta: {
      page: {
        isPublic: true
      },
      breadcrumb: [{
        path: '/impressum',
        key: 'topBar.imprint'
      }, {
        key: 'general.Haftungsausschluss'
      }]
    }
  }, {
    path: '/eula',
    name: 'Eula',
    component: Eula,
    meta: {
      page: {
        key: 'eula.agb',
        isPublic: true
      }
    }
  }, {
    path: '/accept-eula',
    name: 'AcceptEula',
    component: AcceptEula,
    meta: {
      page: {
        key: 'eula.name',
        isPublic: false
      }
    }
  }, {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum,
    meta: {
      page: {
        key: 'topBar.imprint',
        isPublic: true
      }
    }
  }, {
    path: '/devices',
    name: 'Devices',
    component: Ownerships,
    alias: ['/ownerships', '/visualization/status'],
    meta: {
      page: {
        key: 'subtitle.myDevices'
      }
    }
  }, {
    path: '/initialize/:ownership_id',
    name: 'Initialize',
    component: Initialize,
    meta: {
      page: {
        key: 'general.initialize'
      }
    }
  }, {
    path: '/ownership/claim',
    name: 'OwnershipClaim',
    component: OwnershipClaim,
    meta: {
      breadcrumb: [{
        path: '/devices',
        key: 'subtitle.myDevices'
      }, {
        key: 'general.newDevice'
      }]
    }
  }, {
    path: '/ownership/:id',
    name: 'Ownership',
    component: Ownership,
    meta: {
      breadcrumb: [{
        path: '/devices',
        key: 'subtitle.myDevices'
      }, {
        key: 'ownership.editing'
      }]
    }
  }, {
    path: '/modules/:id',
    name: 'Modules',
    component: Modules,
    meta: {
      breadcrumb: [{
        path: '/devices',
        key: 'subtitle.myDevices'
      }, {
        key: 'change.modulename'
      }]
    }
  }, {
    path: '/data-viewer',
    name: 'DataViewer',
    component: DataViewer,
    meta: {
      page: {
        key: 'VBus® Data Viewer'
      }
    }
  }, {
    path: '/discovery-tool',
    name: 'DiscoveryTool',
    component: DiscoveryTool,
    meta: {
      page: {
        isPublic: true,
        key: 'discoveryTool.title'
      }
    }
  }, {
    path: '/settings-documentation',
    name: 'SettingsDocumentationGenerator',
    component: SettingsDocumentationGenerator,
    meta: {
      page: {
        key: 'settingsDocumentation.settingsDocumentationGenerator',
        requires: 'pro'
      }
    }
  }, {
    /*
    path: '/parametrization-rpt',
    name: 'Parametrization RPT',
    component: ParameterizationToolRPT,
    meta: {
      page: {
        key: 'parametrization.header'
      },
      breadcrumb: [{
        path: '/parametrization',
        key: 'sideBar.parametrization'
      }, {
        key: 'parametrization.header'
      }]
    }
  }, {
    */
    path: '/parametrization',
    name: 'Parameterization',
    component: Parameterization,
    meta: {
      page: {
        key: 'sideBar.parametrization',
        requires: 'pro'
      }
    }
  }, {
    path: '/profil',
    name: 'My-Profile',
    component: Profile,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'topBar.editProfile'
      }]
    }
  }, {
    path: '/two-factor-authentication',
    name: 'Two-Factor-Authentication',
    component: TwoFactorAuthentication,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'general.twoFactorAuthentication'
      }]
    }
  }, {
    path: '/templates',
    name: 'Templates',
    component: Templates,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'general.templates'
      }]
    }
  }, {
    path: '/administration',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'Admin-Dashboard'
      }]
    }
  }, {
    path: '/km2-password-seed',
    name: 'KM2-Password',
    component: Km2PasswordSeed,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'KM2-Password-SEED'
      }]
    }
  }, {
    path: '/check-emails',
    name: 'Check-E-Mails',
    component: CheckEmails,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'Check-E-Mails'
      }]
    }

  }, {
    path: '/online-devices',
    name: 'Online-Devices',
    component: OnlineDevices,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'Online-Devices'
      }]
    }
  }, {
    path: '/distribution-dashboard',
    name: 'Distribution-Dashboard',
    component: DistributionDashboard,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'Distribution-Dashboard'
      }]
    }
  }, {
    path: '/support-dashboard',
    name: 'Support-Dashboard',
    component: SupportDashboard,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'Support-Dashboard'
      }]
    }
  }, {
    path: '/statistic',
    name: 'Statistic',
    component: Statistic,
    meta: {
      page: [{
        key: 'Statistic'
      }]
    }
  }, {
    path: '/ownership-data',
    name: 'Ownership-Data',
    component: OwnershipData,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'Ownership-Data'
      }]
    }
  }, {
    path: '/coupon',
    name: 'Coupon',
    component: Coupon,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'coupon.redeemCoupon'
      }]
    }
  }, {
    path: '/default-settings',
    name: 'Default-Settings',
    component: DefaultSettings,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'general.defaultSettings'
      }]
    }
  }, {
    path: '/backup/create',
    name: 'Backup-Create',
    component: BackupCreate,
    meta: {
      page: {
        requires: 'pro'
      },
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'general.backup.create'
      }]
    }
  }, {
    path: '/backup/restore',
    name: 'Backup-Restore',
    component: BackupRestore,
    meta: {
      page: {
        requires: 'pro'
      },
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'general.backup.restore'
      }]
    }
  }, {
    path: '/default-filter-values',
    name: 'Default-Filter-Values',
    component: DefaultFilterSettings,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'default.filter.values'
      }]
    }
  }, {
    path: '/fachpartner',
    name: 'Fachpartner',
    component: MTFAdmin,
    meta: {
      breadcrumb: [{
        path: '/settings',
        key: 'general.preferences'
      }, {
        key: 'Fachpartner'
      }]
    }
  }, {
    path: '*',
    name: '404',
    component: PageNotFound,
    meta: {
      page: {
        key: '404 Not found'
      }
    }
  }, {
    path: '/openweathermap',
    name: 'openweathermap',
    meta: {
      page: {
        key: 'sideBar.dashboard'
      }
    },
    beforeEnter: () => {
      window.open('https://openweathermap.org', '_blank')
    }
  }, {
    path: '/help-videos',
    name: 'helpVideos',
    meta: {
      page: {
        isPublic: true
      }
    },
    beforeEnter: () => {
      window.open('https://www.vbus.net/setup/#/help', '_blank')
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js